import { Card, Divider } from "antd";
import { Formik, Form, Field, ErrorMessage } from "formik";

import "./style.css";

import { InputField, TextAreaField } from "../../components";

const AboutUs = () => {
  return (
    <div className="cotactus-container">
      <Card className="cotactus-card">
        <div className="cotactus-card-right">
          <h3>تماس با ما</h3>
          <Formik
            initialValues={{
              first_name: "",
              phonenumber: "",
              body: "",
            }}
            onSubmit={(values, { setSubmitting }) => {
              // setTimeout(() => {
              //   alert(JSON.stringify(values, null, 2));
              //   setSubmitting(false);
              // }, 400);
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <InputField inputClassname='contactus-input'  name="first_name" title="نام‌ و نام‌خانوادگی" />
                <InputField type='number' inputClassname='contactus-input' name="phonenumber" title="شماره تماس" />
                <TextAreaField inputClassname='contactus-input' name="body" title="متن درخواست" />

                <button className="modal-phonenumber-container-button cotactus-btn">
                  ارسال
                </button>
              </Form>
            )}
          </Formik>
        </div>

        <div className="cotactus-card-left">
          <img src={require("../../assets/images/logo.png")} />
          <p>
            تجربه مشاوره آنلاین و دریافت نوبت از بهترین پزشکان و بیمارستان‌های
            ایران
          </p>
          <Divider />
          <div className="col-lg-12 cotactus-title ">
            <span>تلفن تماس:</span>
            <span>051-91099535</span>
          </div>

          <div className="col-lg-12 cotactus-title">
            <span>آدرس:</span>
            <span className="cotactus-address"> مشهد، بلوار جانباز، جنب پروما، مجتمع نیکا، واحد 602</span>
          </div>
          <div className="col-lg-12 cotactus-title">
            <span>کد پستی:</span>
            <span>9197611983</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AboutUs;
